import React from "react";
var __jsx = React.createElement;
import { useEffect } from "react";
import Layout from "@/_LayoutsRelated/layout/Layout";
import stl from "@/pages/landingPages/LandingPageRoot.module.css";
import SellTradeLanding from "@/pages/module-sell-trade/sell-trade/SellTradeLanding";
import { useTranslation } from "@i18n";
import useIsWebView from "@hooks/useIsWebview";
import useWebView from "@hooks/useWebview";
import useHelpers from "@hooks/useHelpers";
var SellTradePage = function SellTradePage() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isWebView = useIsWebView();
  var webview = useWebView();
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var backClicked = function backClicked() {
    webview.closeScreen()["catch"](function () {
      document.location.href = createUrl("/");
    });
  };
  useEffect(function () {
    webview.showTitleBar(false)["catch"](function () {
      if (isWebView) {
        /** @FIXME TEMP Solution to hide Header for webview on old version ticket [SE-5723] **/
        document.body.classList.add("FIX_ME_OLD_ANDROID_IN_APP_WEBVIEW");
      }
    });
    return function () {
      if (isWebView) {
        /** @FIXME TEMP Solution to hide Header for webview on old version ticket [SE-5723] **/
        document.body.classList.remove("FIX_ME_OLD_ANDROID_IN_APP_WEBVIEW");
      }
    };
  }, [isWebView]);
  var mobileHeader = function mobileHeader() {
    if (isWebView && __IS_SSR__) return null;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: stl.landingMobileHeading
    }, /*#__PURE__*/React.createElement("span", {
      onClick: backClicked
    }), /*#__PURE__*/React.createElement("strong", null, t("بيعنا سيارتك", {
      ns: "web_common"
    }))));
  };
  return /*#__PURE__*/React.createElement(Layout, {
    headHideLinks: true,
    hasNavBar: true,
    authenticationMsg: true,
    linksForSearch: true,
    hideOrangeHeadBtn: true,
    disableLoader: true,
    hideAppBanner: true,
    loading: true,
    mainClass: stl.mainFinancingClass,
    hideHeaderOnmobile: true,
    mobileHasTitle: t("بيعنا سيارتك", {
      ns: "web_common"
    }),
    custommobileHeader: mobileHeader()
  }, /*#__PURE__*/React.createElement(SellTradeLanding, null));
};
export default SellTradePage;